<template>
  <div class="gdash-gauge">
    <wj-bullet-graph
      :min="0"
      :max="250"
      showText="Value"
      :bad="0"
      :good="0"
      :target="100"
      :thumbSize="22"
      :initialized="initialized"
      :value="getValue()"
    >
      <wj-range wjProperty="pointer" :color="palette[1]" :thickness="0" />
      <wj-range wjProperty="face" :thickness="0.1" />
    </wj-bullet-graph>
  </div>
</template>

<script>
import { Range } from "@mescius/wijmo.gauge";

export default {
  name: "GdashGauge",
  props: {
    value: Number,
    palette: Array,
  },
  methods: {
    initialized(gauge) {
      gauge.ranges.push(
        new Range({ min: 97, max: 103, color: "rgb(210, 209, 207)" })
      );
    },
    getValue() {
      return Math.round(this.value * 100);
    },
  },
};
</script>
